import React from "react";
import { Card } from "react-bootstrap";

const HeaderSection = ({
  title,
  description,
  children
}) => {
  return (
    <div className="jobs-library-header">
      <div className="d-flex align-items-center justify-content-between mt-2">
        {/* Left Side - Title & Description */}
        <Card.Body>
          <Card.Title className="text-start jobs-heading mb-1">
            <div className="job-lib-header">
              <h5>{title}</h5>
            </div>
          </Card.Title>
          <Card.Text className="text-start desc-text mt-2">
            <span className="text-body-tertiary jobs-description text-start">
              {description}
            </span>
          </Card.Text>
        </Card.Body>

        {/* Right Side - Action Button */}
        <Card.Body className="d-flex align-items-end justify-content-end flex-column">
          {children}
        </Card.Body>
      </div>
    </div>
  );
};

export default HeaderSection;
